import { crudActions } from '../factories'
import { moduleState } from 'cerebral'

export const { find, setList, clearList, get, save, remove } = crudActions({ name: 'notifications' })

export const getRecipientCount = async ({ props: { audience, geofenceRegion }, store, recipientsService }) => {
  const { count } = await recipientsService.find({ audience, geofenceRegion })
  store.set(moduleState`recipientCount`, count)
  return { count }
}
